/**
 * Nhận diện thương hiệu E-Court / liên hệ chương trình ICFGL (UEL).
 * Tham chiếu sắc độ: https://icfgl.uel.edu.vn/works/icfgl/icfgl-2026/icfgl-2026.html
 */
export const brand = {
  /** Deep Navy — authority, nền pháp lý */
  navy: '#144E8C',
  /** Hot Pink — giọng nói, phá vỡ định kiến, feminist lens */
  hotPink: '#F64183',
  /** Light Pink — mềm mại, hòa nhập */
  lightPink: '#FFEBF2',
  /** Accent Pink — nhấn mạnh, chuyển tiếp */
  accentPink: '#FF9797',
} as const

/** Gradient thương hiệu (nút, card header, logo compact) */
export const gradientBrand = `linear-gradient(135deg, ${brand.navy} 0%, ${brand.hotPink} 100%)`

/** Nền hero / đăng nhập — navy → ánh sáng hồng (gần tinh thần ICFGL) */
export const gradientBackdrop = `linear-gradient(165deg, ${brand.navy} 0%, #1a5c9e 36%, ${brand.lightPink} 78%, #ffffff 100%)`
